import type { Shadows } from '@mui/material/styles/shadows';
import colorLib from 'color';

/**
 * Shadows generation
 */
const getShadowDirection = (index: number, isInset: boolean) => {
  const base = index / 1.5;
  if (isInset) {
    return [`inset ${base}px ${base}px ${base}px`, `0.5px 0.5px 0px`];
  }
  return [`${base}px ${base}px ${base}px`, `0.5px 0.5px 0px`];
};

export const getShadow = (
  index: number,
  options: { colors: [string, string]; isInset?: boolean }
) => {
  const { colors, isInset = false } = options;

  const directions = getShadowDirection(index, isInset);

  return `${directions[0]} ${colors[0]}, ${directions[1]} ${colors[1]}`;
};

export const getThemeShadows = (color: string) =>
  [
    [
      `none`,
      ...[...Array(25)].map((_value, index) =>
        getShadow(index, {
          colors: [colorLib(color).alpha(0.8).toString(), 'rgba(255, 255, 255, .1)'],
        })
      ),
    ],
    [
      `none`,
      ...[...Array(25)].map((_value, index) =>
        getShadow(index, {
          colors: [colorLib(color).alpha(0.8).toString(), 'rgba(255, 255, 255, .1)'],
          isInset: true,
        })
      ),
    ],
  ] as [Shadows, Shadows];
